import { render } from "./GoogleReviewPrompt.vue?vue&type=template&id=87f923ae&scoped=true"
import script from "./GoogleReviewPrompt.vue?vue&type=script&lang=js"
export * from "./GoogleReviewPrompt.vue?vue&type=script&lang=js"

import "./GoogleReviewPrompt.vue?vue&type=style&index=0&id=87f923ae&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Adrian\\OneDrive\\Documents\\Appsanely Ltd\\thankU\\_thankuapp\\thanku\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87f923ae"]])

export default __exports__